

export const getHref = (href: string) => {
    return href.length
        ? '/#' + href
        : '/'
}